import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: '首页' },
  { path: '/categories', label: '服务分类' },
  { path: '/articles', label: '最新资讯' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isTransparent = isHome && !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`text-xl font-heading font-bold whitespace-nowrap transition-colors ${
            isTransparent ? 'text-white' : 'text-foreground-900'
          }`}>
            凌晨不打烊
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  location.pathname === item.path
                    ? isTransparent
                      ? 'bg-white/20 text-white'
                      : 'bg-primary-100 text-primary-700'
                    : isTransparent
                      ? 'text-white/80 hover:text-white hover:bg-white/10'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="/about#contact"
              className="ml-3 px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium whitespace-nowrap transition-all hover:bg-primary-600 cursor-pointer"
            >
              立即咨询
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isTransparent ? 'text-white hover:bg-white/10' : 'text-foreground-700 hover:bg-background-200'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="/about#contact"
              className="mt-2 px-4 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium text-center cursor-pointer"
            >
              立即咨询
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}